export const ACTIVITY_DEFAULT_SORT_FIELD = 'name';
export const ACTIVITY_DEFAULT_SORT_DIRECTION = 'asc';
